module.exports = __webpack_public_path__ + "img/dizzy_face.eba0e4c2.png";